import { CREDIT_LIMITS, CREDIT_MEANING, CREDIT_READ_AGAIN } from "../../../model/credit-words.ts";

// The pricing family's English words (ADR-034 points 1 and 2): only this family edits them. Every
// price and credit count comes from the contracts through a `{name}` place, never from here.
export const PRICING_WORDS_EN = {
  footerTitle: "Pricing",
  footerLink: "Plans and credits",
  creditMeaning: CREDIT_MEANING.en,
  keyphrase: "pricing",
  title: "Pricing: plans and credits · {product}",
  description:
    "{product} pricing: start free with {welcome} credits, paid plans from {price} a month. {meaning}",
  breadcrumbHome: "Home",
  breadcrumbPage: "Pricing",
  eyebrow: "Plans and credits",
  heading: "Pricing: start free on {welcome} credits",
  lede: "{meaning} {limits}",
  plansTitle: "Choose a plan",
  plansDescription: "Prices are in euros. VAT is added where it applies.",
  periodLabel: "Billing period",
  mostPopular: "Most Popular",
  periodMonth: "Monthly",
  periodYear: "Yearly",
  periodDiscount: "-{discount}%",
  perMonth: "/month",
  perYear: "/year",
  billedMonthly: "Billed every month",
  billedYearly: "{discount}% off, billed once a year",
  plans: {
    free: {
      name: "Free",
      tagline: "Try it on a real account",
      action: "Get started free",
      lines: ["{welcome} welcome credits, once", "{seats} seats", "No credit card"],
    },
    starter: {
      tagline: "For small businesses and freelancers",
      action: "Choose Starter",
    },
    growth: {
      tagline: "For teams that reach more people",
      action: "Choose Growth",
    },
    enterprise: {
      tagline: "For growing teams",
      action: "Choose Enterprise",
    },
  },
  creditsLine: "{credits} credits a month",
  seatsLine: "{seats} seats",
  helperTitle: "How many credits do you need?",
  helperLabel: "Credits a month",
  helperEmpty: "Enter a number of credits to see the cheapest way to cover it.",
  helperWelcome: "The {plan} plan's {welcome} welcome credits cover {credits}, once, with no card.",
  helperMonth: "{plan} covers {credits} credits, at {price} a month.",
  helperYear: "{plan} covers {credits} credits, at {price} a year.",
  helperPackAlone: "A {pack} pack covers {credits} credits, paid once, with no plan.",
  helperPacksAlone: "{count} packs for {pack} cover {credits} credits, paid once, with no plan.",
  helperPlanPackMonth: "{plan} plus a {pack} pack covers {credits} credits, for {total} the first month.",
  helperPlanPacksMonth:
    "{plan} plus {count} packs for {pack} covers {credits} credits, for {total} the first month.",
  helperPlanPackYear:
    "{plan} at {price} a year plus a {pack} pack covers {credits} credits, {total} up front.",
  helperPlanPacksYear:
    "{plan} at {price} a year plus {count} packs for {pack} covers {credits} credits, {total} up front.",
  helperPacksOnce: "Packs are paid once and carry over, so needing {credits} every month means buying more.",
  helperAlsoMonth:
    "{plan} includes {included} credits a month for {price} a month, with more sending accounts.",
  helperAlsoYear:
    "{plan} includes {included} credits a month for {price} a year, with more sending accounts.",
  helperPack: "Extra credits start at {price} for {credits}, paid once, and carry over until used.",
  faqLabel: "FAQ",
  faqTitle: "Questions, answered",
  relatedTitle: "See it in use",
  questions: [
    {
      question: "What does a credit buy?",
      answer: `${CREDIT_MEANING.en} ${CREDIT_LIMITS.en} ${CREDIT_READ_AGAIN.en}`,
    },
    {
      question: "Which accounts can I read?",
      answer: "An Instagram account's followers, and the accounts it follows.",
    },
    {
      question: "Do I need a card for the free plan?",
      answer: "No. Your {welcome} welcome credits come once, after you verify your email.",
    },
    {
      question: "Can I pay yearly?",
      answer: "Yes, with {discount}% off the monthly price, billed once a year.",
    },
    {
      question: "Do unused credits carry over?",
      answer:
        "A plan's credits do not carry over to the next month. Credit packs you buy separately carry over until used.",
    },
  ],
};
